export const safeJsonParse = <T>(str: string) => {
	try {
		const jsonValue: T = JSON.parse(str) as T;
		return jsonValue;
	} catch {
		return undefined;
	}
};

export const getFromLocalStorage = <T>(key: string) => {
	const strValue = localStorage.getItem(key);
	if (strValue) {
		return safeJsonParse<T>(strValue);
	}
};
